import React from 'react';

interface FireModeBannerProps {
  isActive: boolean;
}

const FireModeBanner: React.FC<FireModeBannerProps> = ({ isActive }) => {
  if (!isActive) return null;

  return (
    <div className="bg-red-600 text-white py-2 px-4 text-center font-bold text-sm animate-pulse z-50 sticky top-0">
      🔥 FIRE EVACUATION MODE ACTIVE - EMERGENCY PROTOCOL ENGAGED 🔥
    </div>
  );
};

export default FireModeBanner;

